import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const Modal= ({ dataTestId,dismissClickOutsideModal=true, children, visible, close, addClass, variant = 'small' }) => {
	const modalWrapperClass = classNames({
		'DS__modal_wrapper--small': variant === 'small',
		'DS__modal_wrapper--medium': variant === 'medium',
		'DS__modal_wrapper--large': variant === 'large'
	});

	const handleClickOutside = (e) => {
		if (dismissClickOutsideModal) {
		  close();
		} else {
		  e.stopPropagation();
		}
	  };

	return visible
		? ReactDOM.createPortal(
				<div className={`DS__modal ${addClass ?? ''}`} data-testid={dataTestId}>
					<div className="DS__modal__content"
					onClick={handleClickOutside}
					>
						<div className={`${modalWrapperClass} DS__modal_box`}>
							<div  onClick={(e) => e.stopPropagation()}>
								{children}
							</div>
						</div>
					</div>
				</div>,
				document.body
		  )
		: null;
};

// PropTypes for Modal component
Modal.propTypes = {
	dataTestId: PropTypes.string,
	dismissClickOutsideModal: PropTypes.bool,
	children: PropTypes.node,
	visible: PropTypes.bool,
	close: PropTypes.func,
	addClass: PropTypes.string,
	variant: PropTypes.oneOf(['small', 'medium', 'large']),
  };

  Modal.defaultProps = {
	dismissClickOutsideModal: true,
	variant: 'small',
  };
export default Modal;
